export default {
  CONTEXTS: {
    FOLDER: 1,
    RECENT: 2,
    SEARCH: 4,
  },
};
